<template>
  <div class="header">

    <template v-if="!menuIsOpen">
      <div class="menu-icon animated-icon menu-cross" @click="changeMenuStatus"  :title="this.$t('header.menuButtonTitle')" :class="{ anim : menuIsOpen}">
        <div class="ani"></div>
      </div>
    </template>

    <div class="mdk8-logo">
      <router-link to="/" :title="this.$t('header.medik8LogoTitle')"><img 
          src="../assets/logos/by-medik8-xl.png"
          srcset="../assets/logos/by-medik8-s.png 300w,
                  ../assets/logos/by-medik8-l.png 600w,
                  ../assets/logos/by-medik8-xl.png 900w"
          alt="By Medik8 Logo"></router-link>
    </div>

    <div class="icons-right">
      <a :href="$core.header.homepage" target="_blank" :title="this.$t('header.backToMedik8Title')"><img src="../assets/images/all/home.png" alt=""></a>
      <a :href="$core.header.shop"  :title="this.$t('header.shopNowTitle')" target="_blank"><img src="../assets/images/all/bag.png" alt=""></a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  
  .header {
    padding:20px;
    position:absolute;
    width:100%;
    top:0px;
    left:0px;
    background:black;
    color:white;
    display:flex;
    justify-content:center;
    align-items:center;
    min-height: 50px;
    z-index:2;
    .menu-icon{
      position:absolute;
      left:10px;
      @media screen and (min-width:600px){
        left:20px;
      }
    }
    .mdk8-logo{
      max-width:100px;
      
      @media screen and (min-width:600px){
        max-width:130px;
      }
    
      @media screen and (min-width:1920px){
        max-width:160px;
      }
    }
    .icons-right{
      position: absolute;
      right: 10px;
      font-size: 20px;
      font-size: calc(18px + 0.8vw);
      color:white;
      img{
        width:22px;
        @media screen and (min-width:600px){
          width:30px;
        }
      }
      @media screen and (min-width:600px){
        font-size: calc(12px + 0.8vw);
        right:20px;
      }
      a{
        color:white;
        position:relative;
        z-index:100;
        margin:0px 10px;
        @media screen and (min-width:600px){
           margin:0px 14px;
        }
      }
      i{
        color:white;
      }
      a:first-child{
        margin-right:5px;
        img{
          position:relative; 
          width:23px;
          top:1px;
          @media screen and (min-width:600px){
            width:30px;
          }
        }
      }
    }  
  }  



  

</style>



<script>
  import appMenu  from './app-menu.vue'

  export default{
    components:{
      appMenu
    },
    methods: {
      changeMenuStatus() {
        this.$store.state.menuIsOpen = !this.$store.state.menuIsOpen;
      }
    },
    computed: {
      menuIsOpen() {
        return this.$store.state.menuIsOpen;
      }
    }
  }
</script>



